/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedSearchIndexRouteImport } from './routes/_authed/search/index'
import { Route as AuthedCustomersIndexRouteImport } from './routes/_authed/customers/index'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedSystemsUnassignedIndexRouteImport } from './routes/_authed/systems/unassigned/index'
import { Route as AuthedSystemsSystemIdIndexRouteImport } from './routes/_authed/systems/$systemId/index'
import { Route as AuthedCustomersCustomerIdIndexRouteImport } from './routes/_authed/customers/$customerId/index'
import { Route as AuthedAdminSystemsIndexRouteImport } from './routes/_authed/admin/systems/index'
import { Route as AuthedAdminManageUsersIndexRouteImport } from './routes/_authed/admin/manage-users/index'
import { Route as AuthedAdminLicenseViewerIndexRouteImport } from './routes/_authed/admin/license-viewer/index'
import { Route as AuthedAdminDeploymentCenterIndexRouteImport } from './routes/_authed/admin/deployment-center/index'
import { Route as AuthedAdminCustomerImportsIndexRouteImport } from './routes/_authed/admin/customer-imports/index'
import { Route as AuthedAdminDeploymentCenterSystemStatusIndexRouteImport } from './routes/_authed/admin/deployment-center/system-status/index'
import { Route as AuthedAdminDeploymentCenterPackagesIndexRouteImport } from './routes/_authed/admin/deployment-center/packages/index'
import { Route as AuthedAdminDeploymentCenterDeployIndexRouteImport } from './routes/_authed/admin/deployment-center/deploy/index'

const AuthedRoute = AuthedRouteImport.update({
  id: '/authed',
  path: '/authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSearchIndexRoute = AuthedSearchIndexRouteImport.update({
  id: '/_authed/search/',
  path: '/search/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedCustomersIndexRoute = AuthedCustomersIndexRouteImport.update({
  id: '/_authed/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/_authed/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSystemsUnassignedIndexRoute =
  AuthedSystemsUnassignedIndexRouteImport.update({
    id: '/_authed/systems/unassigned/',
    path: '/systems/unassigned/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedSystemsSystemIdIndexRoute =
  AuthedSystemsSystemIdIndexRouteImport.update({
    id: '/_authed/systems/$systemId/',
    path: '/systems/$systemId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedCustomersCustomerIdIndexRoute =
  AuthedCustomersCustomerIdIndexRouteImport.update({
    id: '/_authed/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminSystemsIndexRoute = AuthedAdminSystemsIndexRouteImport.update({
  id: '/_authed/admin/systems/',
  path: '/admin/systems/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminManageUsersIndexRoute =
  AuthedAdminManageUsersIndexRouteImport.update({
    id: '/_authed/admin/manage-users/',
    path: '/admin/manage-users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminLicenseViewerIndexRoute =
  AuthedAdminLicenseViewerIndexRouteImport.update({
    id: '/_authed/admin/license-viewer/',
    path: '/admin/license-viewer/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminDeploymentCenterIndexRoute =
  AuthedAdminDeploymentCenterIndexRouteImport.update({
    id: '/_authed/admin/deployment-center/',
    path: '/admin/deployment-center/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminCustomerImportsIndexRoute =
  AuthedAdminCustomerImportsIndexRouteImport.update({
    id: '/_authed/admin/customer-imports/',
    path: '/admin/customer-imports/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminDeploymentCenterSystemStatusIndexRoute =
  AuthedAdminDeploymentCenterSystemStatusIndexRouteImport.update({
    id: '/_authed/admin/deployment-center/system-status/',
    path: '/admin/deployment-center/system-status/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminDeploymentCenterPackagesIndexRoute =
  AuthedAdminDeploymentCenterPackagesIndexRouteImport.update({
    id: '/_authed/admin/deployment-center/packages/',
    path: '/admin/deployment-center/packages/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminDeploymentCenterDeployIndexRoute =
  AuthedAdminDeploymentCenterDeployIndexRouteImport.update({
    id: '/_authed/admin/deployment-center/deploy/',
    path: '/admin/deployment-center/deploy/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authed': typeof AuthedRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/customers': typeof AuthedCustomersIndexRoute
  '/search': typeof AuthedSearchIndexRoute
  '/admin/customer-imports': typeof AuthedAdminCustomerImportsIndexRoute
  '/admin/deployment-center': typeof AuthedAdminDeploymentCenterIndexRoute
  '/admin/license-viewer': typeof AuthedAdminLicenseViewerIndexRoute
  '/admin/manage-users': typeof AuthedAdminManageUsersIndexRoute
  '/admin/systems': typeof AuthedAdminSystemsIndexRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdIndexRoute
  '/systems/$systemId': typeof AuthedSystemsSystemIdIndexRoute
  '/systems/unassigned': typeof AuthedSystemsUnassignedIndexRoute
  '/admin/deployment-center/deploy': typeof AuthedAdminDeploymentCenterDeployIndexRoute
  '/admin/deployment-center/packages': typeof AuthedAdminDeploymentCenterPackagesIndexRoute
  '/admin/deployment-center/system-status': typeof AuthedAdminDeploymentCenterSystemStatusIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authed': typeof AuthedRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/customers': typeof AuthedCustomersIndexRoute
  '/search': typeof AuthedSearchIndexRoute
  '/admin/customer-imports': typeof AuthedAdminCustomerImportsIndexRoute
  '/admin/deployment-center': typeof AuthedAdminDeploymentCenterIndexRoute
  '/admin/license-viewer': typeof AuthedAdminLicenseViewerIndexRoute
  '/admin/manage-users': typeof AuthedAdminManageUsersIndexRoute
  '/admin/systems': typeof AuthedAdminSystemsIndexRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdIndexRoute
  '/systems/$systemId': typeof AuthedSystemsSystemIdIndexRoute
  '/systems/unassigned': typeof AuthedSystemsUnassignedIndexRoute
  '/admin/deployment-center/deploy': typeof AuthedAdminDeploymentCenterDeployIndexRoute
  '/admin/deployment-center/packages': typeof AuthedAdminDeploymentCenterPackagesIndexRoute
  '/admin/deployment-center/system-status': typeof AuthedAdminDeploymentCenterSystemStatusIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/authed': typeof AuthedRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/customers/': typeof AuthedCustomersIndexRoute
  '/_authed/search/': typeof AuthedSearchIndexRoute
  '/_authed/admin/customer-imports/': typeof AuthedAdminCustomerImportsIndexRoute
  '/_authed/admin/deployment-center/': typeof AuthedAdminDeploymentCenterIndexRoute
  '/_authed/admin/license-viewer/': typeof AuthedAdminLicenseViewerIndexRoute
  '/_authed/admin/manage-users/': typeof AuthedAdminManageUsersIndexRoute
  '/_authed/admin/systems/': typeof AuthedAdminSystemsIndexRoute
  '/_authed/customers/$customerId/': typeof AuthedCustomersCustomerIdIndexRoute
  '/_authed/systems/$systemId/': typeof AuthedSystemsSystemIdIndexRoute
  '/_authed/systems/unassigned/': typeof AuthedSystemsUnassignedIndexRoute
  '/_authed/admin/deployment-center/deploy/': typeof AuthedAdminDeploymentCenterDeployIndexRoute
  '/_authed/admin/deployment-center/packages/': typeof AuthedAdminDeploymentCenterPackagesIndexRoute
  '/_authed/admin/deployment-center/system-status/': typeof AuthedAdminDeploymentCenterSystemStatusIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authed'
    | '/admin'
    | '/customers'
    | '/search'
    | '/admin/customer-imports'
    | '/admin/deployment-center'
    | '/admin/license-viewer'
    | '/admin/manage-users'
    | '/admin/systems'
    | '/customers/$customerId'
    | '/systems/$systemId'
    | '/systems/unassigned'
    | '/admin/deployment-center/deploy'
    | '/admin/deployment-center/packages'
    | '/admin/deployment-center/system-status'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authed'
    | '/admin'
    | '/customers'
    | '/search'
    | '/admin/customer-imports'
    | '/admin/deployment-center'
    | '/admin/license-viewer'
    | '/admin/manage-users'
    | '/admin/systems'
    | '/customers/$customerId'
    | '/systems/$systemId'
    | '/systems/unassigned'
    | '/admin/deployment-center/deploy'
    | '/admin/deployment-center/packages'
    | '/admin/deployment-center/system-status'
  id:
    | '__root__'
    | '/'
    | '/authed'
    | '/_authed/admin/'
    | '/_authed/customers/'
    | '/_authed/search/'
    | '/_authed/admin/customer-imports/'
    | '/_authed/admin/deployment-center/'
    | '/_authed/admin/license-viewer/'
    | '/_authed/admin/manage-users/'
    | '/_authed/admin/systems/'
    | '/_authed/customers/$customerId/'
    | '/_authed/systems/$systemId/'
    | '/_authed/systems/unassigned/'
    | '/_authed/admin/deployment-center/deploy/'
    | '/_authed/admin/deployment-center/packages/'
    | '/_authed/admin/deployment-center/system-status/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedCustomersIndexRoute: typeof AuthedCustomersIndexRoute
  AuthedSearchIndexRoute: typeof AuthedSearchIndexRoute
  AuthedAdminCustomerImportsIndexRoute: typeof AuthedAdminCustomerImportsIndexRoute
  AuthedAdminDeploymentCenterIndexRoute: typeof AuthedAdminDeploymentCenterIndexRoute
  AuthedAdminLicenseViewerIndexRoute: typeof AuthedAdminLicenseViewerIndexRoute
  AuthedAdminManageUsersIndexRoute: typeof AuthedAdminManageUsersIndexRoute
  AuthedAdminSystemsIndexRoute: typeof AuthedAdminSystemsIndexRoute
  AuthedCustomersCustomerIdIndexRoute: typeof AuthedCustomersCustomerIdIndexRoute
  AuthedSystemsSystemIdIndexRoute: typeof AuthedSystemsSystemIdIndexRoute
  AuthedSystemsUnassignedIndexRoute: typeof AuthedSystemsUnassignedIndexRoute
  AuthedAdminDeploymentCenterDeployIndexRoute: typeof AuthedAdminDeploymentCenterDeployIndexRoute
  AuthedAdminDeploymentCenterPackagesIndexRoute: typeof AuthedAdminDeploymentCenterPackagesIndexRoute
  AuthedAdminDeploymentCenterSystemStatusIndexRoute: typeof AuthedAdminDeploymentCenterSystemStatusIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/authed': {
      id: '/authed'
      path: '/authed'
      fullPath: '/authed'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/search/': {
      id: '/_authed/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthedSearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/customers/': {
      id: '/_authed/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthedCustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/systems/unassigned/': {
      id: '/_authed/systems/unassigned/'
      path: '/systems/unassigned'
      fullPath: '/systems/unassigned'
      preLoaderRoute: typeof AuthedSystemsUnassignedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/systems/$systemId/': {
      id: '/_authed/systems/$systemId/'
      path: '/systems/$systemId'
      fullPath: '/systems/$systemId'
      preLoaderRoute: typeof AuthedSystemsSystemIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/customers/$customerId/': {
      id: '/_authed/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthedCustomersCustomerIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/systems/': {
      id: '/_authed/admin/systems/'
      path: '/admin/systems'
      fullPath: '/admin/systems'
      preLoaderRoute: typeof AuthedAdminSystemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/manage-users/': {
      id: '/_authed/admin/manage-users/'
      path: '/admin/manage-users'
      fullPath: '/admin/manage-users'
      preLoaderRoute: typeof AuthedAdminManageUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/license-viewer/': {
      id: '/_authed/admin/license-viewer/'
      path: '/admin/license-viewer'
      fullPath: '/admin/license-viewer'
      preLoaderRoute: typeof AuthedAdminLicenseViewerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/deployment-center/': {
      id: '/_authed/admin/deployment-center/'
      path: '/admin/deployment-center'
      fullPath: '/admin/deployment-center'
      preLoaderRoute: typeof AuthedAdminDeploymentCenterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/customer-imports/': {
      id: '/_authed/admin/customer-imports/'
      path: '/admin/customer-imports'
      fullPath: '/admin/customer-imports'
      preLoaderRoute: typeof AuthedAdminCustomerImportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/deployment-center/system-status/': {
      id: '/_authed/admin/deployment-center/system-status/'
      path: '/admin/deployment-center/system-status'
      fullPath: '/admin/deployment-center/system-status'
      preLoaderRoute: typeof AuthedAdminDeploymentCenterSystemStatusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/deployment-center/packages/': {
      id: '/_authed/admin/deployment-center/packages/'
      path: '/admin/deployment-center/packages'
      fullPath: '/admin/deployment-center/packages'
      preLoaderRoute: typeof AuthedAdminDeploymentCenterPackagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/deployment-center/deploy/': {
      id: '/_authed/admin/deployment-center/deploy/'
      path: '/admin/deployment-center/deploy'
      fullPath: '/admin/deployment-center/deploy'
      preLoaderRoute: typeof AuthedAdminDeploymentCenterDeployIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedCustomersIndexRoute: AuthedCustomersIndexRoute,
  AuthedSearchIndexRoute: AuthedSearchIndexRoute,
  AuthedAdminCustomerImportsIndexRoute: AuthedAdminCustomerImportsIndexRoute,
  AuthedAdminDeploymentCenterIndexRoute: AuthedAdminDeploymentCenterIndexRoute,
  AuthedAdminLicenseViewerIndexRoute: AuthedAdminLicenseViewerIndexRoute,
  AuthedAdminManageUsersIndexRoute: AuthedAdminManageUsersIndexRoute,
  AuthedAdminSystemsIndexRoute: AuthedAdminSystemsIndexRoute,
  AuthedCustomersCustomerIdIndexRoute: AuthedCustomersCustomerIdIndexRoute,
  AuthedSystemsSystemIdIndexRoute: AuthedSystemsSystemIdIndexRoute,
  AuthedSystemsUnassignedIndexRoute: AuthedSystemsUnassignedIndexRoute,
  AuthedAdminDeploymentCenterDeployIndexRoute:
    AuthedAdminDeploymentCenterDeployIndexRoute,
  AuthedAdminDeploymentCenterPackagesIndexRoute:
    AuthedAdminDeploymentCenterPackagesIndexRoute,
  AuthedAdminDeploymentCenterSystemStatusIndexRoute:
    AuthedAdminDeploymentCenterSystemStatusIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
